import React, { createContext, useContext, useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { getCurrentUser } from 'aws-amplify/auth';
import LoadingIcon from '../../icons/LoadingIcon';


export type SocialNetworkName = 'instagram' | 'facebook' | 'tiktok';

export interface SocialNetwork {
  name: SocialNetworkName;
  followers: number;
  handleName: string;
}

export interface Website {
  url: string;
}

export interface Creator {
  id: string;
  fullName: string;
  tagline?: string;
  about: string;
  categories: Array<string>;
  socialNetworks: Array<SocialNetwork>;
  website: Website;
  headshot: string;
  coverphoto: string;
  coverImage?:string;
  userId?:string;
}

const initialCreator: Creator = {
  id: '',
  fullName: '',
  tagline: '',
  about: '',
  categories: [],
  socialNetworks: [],
  website: { url: '' },
  headshot: '',
  coverphoto: '',
  coverImage:''
};

interface CreatorContextProps {
  creator: Creator;
  setCreator: React.Dispatch<React.SetStateAction<Creator>>;
}

const CreatorContext = createContext<CreatorContextProps | undefined>(undefined);

export const CreatorProvider: React.FC = () => {

  const [creator, setCreator] = useState<Creator>(initialCreator);
  const [isUserValid, setIsUserValid] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkUser = async () => {
      try {
        await getCurrentUser();
        setIsUserValid(true);
      } catch (error) {
        setIsUserValid(false);
      } finally {
        setLoading(false);
      }
    };

    checkUser();
  }, []); 

  
  if (loading) {
    return (
      <div className="grid place-items-center h-screen w-full">
        <div>
          <LoadingIcon width={150} height={150} />
        </div>
      </div>
    );
  }
  if (!isUserValid) {
    return <Navigate to="/" replace />;
  }

  return (
    <CreatorContext.Provider value={{ creator, setCreator }}>
      <Outlet />
    </CreatorContext.Provider>
  );
};

export const useCreator = (): CreatorContextProps => {
  const context = useContext(CreatorContext);
  if (!context) {
    throw new Error('useCreator must be used within an CreatorProvider');
  }
  return context;
};
